import Vue from 'vue';

export default Vue.extend({
   data: function () {
       return {
           value: ''
       };
   },
   beforeMount() {
       this.value = this.params.value;
   },
    template: `<span v-if="value=='Y'">완료</span>`,
})